var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSend(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.4228 8.51013L9.8628 4.23013C4.1128 1.35013 1.7528 3.71013 4.6328 9.46013L5.5028 11.2001C5.7528 11.7101 5.7528 12.3001 5.5028 12.8101L4.6328 14.5401C1.7528 20.2901 4.1028 22.6501 9.8628 19.7701L18.4228 15.4901C22.2628 13.5701 22.2628 10.4301 18.4228 8.51013ZM15.1928 12.7501H9.7928C9.3828 12.7501 9.0428 12.4101 9.0428 12.0001C9.0428 11.5901 9.3828 11.2501 9.7928 11.2501H15.1928C15.6028 11.2501 15.9428 11.5901 15.9428 12.0001C15.9428 12.4101 15.6028 12.7501 15.1928 12.7501Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSend);
export default __webpack_public_path__ + "static/media/send.de823c21d8adf55ccb4a708df7cde322.svg";
export { ForwardRef as ReactComponent };